<template>
  <Modal v-if="showModalServiceRequest" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="serviceRequest">
      <div class="serviceRequest__header">
        <span class="title">{{ $t('descriptionServiceRequest') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="serviceRequest__body">
        <FormKit
          type="form"
          id="description-form"
          v-model="formData"
          :actions="false"
          @submit="$emit('saveServiceRequest', formData)"
        >
          <label class="label-description" for="description">
            {{ $t('description') }}
          </label>
          <textarea
            v-model="formData.description"
            id="description"
            class="input-description"
            maxlength="250"
          >
          </textarea>
        </FormKit>
      </div>
      <div class="serviceRequest__buttons">
        <Button variant="filled" :title="$t('save')" @click="submitHandler" />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'ServiceRequest',
  props: ['showModalServiceRequest'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      formData: {
        description: '',
        serviceRequest: false
      }
    };
  },
  methods: {
    submitHandler() {
      this.$formkit.submit('description-form');
    }
  }
})
export default class ServiceRequestComment extends Vue {}
</script>

<style lang="scss">
.serviceRequest {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .serviceRequest__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .serviceRequest__body {
    position: relative;
    margin-bottom: 24px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 319px;
      height: 200px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .serviceRequest__buttons {
    display: flex;
    justify-content: space-between;
    .button {
      width: 170px;
    }
  }
}
</style>
